
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-layout-effect",
      function () {
        return require("private-next-pages/use-layout-effect/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-layout-effect"])
      });
    }
  